import domReady from '@wordpress/dom-ready';
import $ from 'jquery';

domReady( function () {
	const root = document.documentElement,
		slick = window.slick,
		sliders = $( '[rel="products-grid"]' );
	const settings = {
		dots: true,
		arrows: true,
		mobileFirst: true,
		appendArrows: $( '.products-list-navigation' ),
		appendDots: $( '.products-list-navigation' ),
		infinite: false,
		slidesToShow: 2.5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1.5,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2.5,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3.5,
				},
			},
		],
	};

	sliders.on( 'init', function ( slick ) {
		// console.log( slick.target.slick );
		setTimeout( () => {
			// console.log( slick );
			root.style.setProperty(
				'--slider-box-height',
				`${
					slick.currentTarget.slick.$slideTrack[ 0 ].clientHeight - 40
				}px`
			);
			// root.style.setProperty(
			// 	'--slider-box-width',
			// 	`${ slick.currentTarget.slick.$slides[ 0 ].clientWidth }px`
			// );
		}, 500 );
	} );

	sliders.slick( settings );
} );
